<template>
    <div :style="node.depth > 1 ? 'margin-left: 30px;' : 'margin-left: 55px;'">
        <input type="checkbox" @change="selectLeaf" v-model="selected" :name="'label-' + node.id" :id="'label-' + node.id">
        <label :for="'label-' + node.id"
               style="display: inline !important; font-size: inherit !important;">
            {{ node.name }}
        </label>

        <template v-if="node.children && node.children.length > 0">
            <node v-for="child in node.children" :node="child" :key="child.id" v-on="$listeners" />
        </template>
    </div>
</template>

<script>
    export default {
        name: 'node',
        props: { node: Object },
        data: () => ({
            selected: false
        }),
        methods: {
            selectLeaf() {
                this.$emit('leafChecked', {id: this.node.id, checked: this.selected, text: this.node.name})
            }
        }
    }
</script>
